import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10 * (props.wx ?? 1)}
    height={33 * (props.hx ?? 1)}
    viewBox="0 0 10 33"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.684 23.803c-.05-.377-.136-1.161-.438-1.881-.296-.703-.581-1.413-.684-2.168-.556-4.08-.44-8.537-1.613-13.42-.78-3.248-.83-5.215-1.38-5.328C3.96.88 3.136 2.858 3.075 6.464c-.085 5.046-.991 10.038-1.206 13.168-.1 1.474-.479 2.267-.588 2.657a6.4 6.4 0 0 0-.194 1.152c-.13 1.46-.101 4.427.01 6.467.064 1.195.219 1.683 1.062 1.762 1.816.168 4.415.117 6.044-.104.588-.08.639-.51.655-1.3.039-1.921.077-4.616-.173-6.463"
    />
  </svg>
);
export default SvgNormal;
